import Typography from '@mui/material/Typography';
import { ImagenProtegida } from '../diseno/ImagenProtegida';
import { useMarca } from './ProveedorDeMarca';

interface Props {
  /** Alto disponible en pixeles. El ancho se deduce de la imagen. */
  alto?: number;
  /** En documentos impresos conviene un poco mas de alto. */
  variante?: 'barra' | 'documento';
  /** Sobre el color del consultorio (barra lateral): el nombre en texto va en blanco. */
  sobreAcento?: boolean;
}

/**
 * Logo del consultorio, o su nombre en texto si todavia no subio uno.
 *
 * Se fija el ALTO y se deja el ancho en `auto`. El sistema anterior fijaba alto
 * y ancho a la vez (118x40), asi que cualquier logo con otra proporcion salia
 * estirado: con un cliente por despliegue no se notaba, con muchos si.
 */
export function Logo({ alto, variante = 'barra', sobreAcento = false }: Props) {
  const { marca } = useMarca();
  const altoEfectivo = alto ?? (variante === 'documento' ? 56 : 36);

  if (!marca.logoUrl) {
    return (
      // El nombre sin logo lleva el texto del acento derivado de la marca: es
      // el color del consultorio ya ajustado para leerse AA en claro y oscuro.
      <Typography
        variant={variante === 'documento' ? 'h2' : 'h4'}
        component="span"
        noWrap
        sx={{
          display: 'block',
          maxWidth: '100%',
          fontWeight: 700,
          letterSpacing: variante === 'documento' ? undefined : '-0.015em',
          color: sobreAcento ? 'var(--accent-on)' : 'var(--accent-text)',
        }}
      >
        {marca.nombreComercial}
      </Typography>
    );
  }

  return (
    // El logo vive en el endpoint autenticado de archivos: un `src` directo
    // saldria roto. Las paginas publicas no lo muestran (ver PortalAgenda).
    <ImagenProtegida
      url={marca.logoUrl}
      alt={marca.nombreComercial}
      sx={{
        height: altoEfectivo,
        width: 'auto',
        maxWidth: variante === 'documento' ? 260 : 'min(100%, 200px)',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}
